import { gql } from '@apollo/client';

// 调账任务查询
export const GET_ADJUSTMENT_TASKS = gql`
  query GetAdjustmentTasks($billId: ID!) {
    getAdjustmentTasks(billId: $billId) {
      taskId
      adjustmentType
      adjustmentAmount
      amountBefore
      amountAfter
      feeItemName
      reason
      submitterId
      submitterName
      submittedAt
      status
      attachmentFileName
    }
  }
`;

// 调账附件预签名下载地址（对象键由后端从调账记录取，不由前端传）
export const GET_ADJUSTMENT_ATTACHMENT_DOWNLOAD_URL = gql`
  query GetAdjustmentAttachmentDownloadUrl($taskId: Long!) {
    getAdjustmentAttachmentDownloadUrl(taskId: $taskId)
  }
`;

// 删除调账附件（清空调账记录上的附件字段，仅有调账权限的人可操作）
export const DELETE_ADJUSTMENT_ATTACHMENT = gql`
  mutation DeleteAdjustmentAttachment($taskId: Long!) {
    deleteAdjustmentAttachment(taskId: $taskId)
  }
`;

// 单个调账任务查询
export const GET_ADJUSTMENT_TASK = gql`
  query GetAdjustmentTask($taskId: ID!) {
    getAdjustmentTask(taskId: $taskId) {
      taskId
      adjustmentType
      adjustmentAmount
      amountBefore
      amountAfter
      feeItemName
      reason
      submitterId
      submitterName
      submittedAt
      status
    }
  }
`;

// 检查账单调账权限
export const CAN_BILL_ADJUST = gql`
  query CanBillAdjust($billId: ID!) {
    canBillAdjust(billId: $billId)
  }
`;

// 创建调账任务
export const CREATE_ADJUSTMENT_TASK = gql`
  mutation CreateAdjustmentTask($billId: ID!, $adjustmentRequest: AdjustmentRequestInput!) {
    createAdjustmentTask(billId: $billId, adjustmentRequest: $adjustmentRequest) {
      taskId
      success
      errorMessage
    }
  }
`;

// 批量创建调账任务
export const CREATE_BATCH_ADJUSTMENT_TASKS = gql`
  mutation CreateBatchAdjustmentTasks($billId: ID!, $batchRequest: BatchAdjustmentRequestInput!) {
    createBatchAdjustmentTasks(billId: $billId, batchRequest: $batchRequest) {
      successCount
      failureCount
      failures {
        feeItemId
        reason
      }
    }
  }
`;

// 审核调账任务
export const AUDIT_ADJUSTMENT_TASK = gql`
  mutation AuditAdjustmentTask($taskId: ID!, $approved: Boolean!, $auditComment: String) {
    auditAdjustmentTask(taskId: $taskId, approved: $approved, auditComment: $auditComment) {
      taskId
      success
      errorMessage
    }
  }
`;

// 执行调账任务
export const EXECUTE_ADJUSTMENT_TASK = gql`
  mutation ExecuteAdjustmentTask($taskId: ID!) {
    executeAdjustmentTask(taskId: $taskId) {
      taskId
      success
      errorMessage
    }
  }
`;

// 取消调账任务
export const CANCEL_ADJUSTMENT_TASK = gql`
  mutation CancelAdjustmentTask($taskId: ID!, $reason: String!) {
    cancelAdjustmentTask(taskId: $taskId, reason: $reason) {
      taskId
      success
      errorMessage
    }
  }
`;
